import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';

import { useUserContext } from 'src/components/app/context/UserContext';
import LanguageSwitcher from 'src/components/common/LanguageSwitcher';
import SettingsMenu from 'src/components/common/SettingsMenu';
import SurveySwitcher from 'src/components/common/SurveySwitcher';

import { styles } from './index.styles';

interface MetaNavigationProps {
  hideSurveySettings?: boolean;
}

const MetaNavigation: FC<MetaNavigationProps> = ({ hideSurveySettings }) => {
  const { triggerAutoLogout, user } = useUserContext();
  const { t } = useTranslation('common');

  return (
    <Box className="MetaNavigation-root" sx={styles.metaNavigation}>
      <LanguageSwitcher color="secondary" />

      {!!user && (
        <>
          <Typography sx={styles.currentUser}>
            {t('user')}: {user.first_name} {user.last_name}
          </Typography>

          <SurveySwitcher />
          {!hideSurveySettings && <SettingsMenu />}

          <Button
            color="inherit"
            onClick={() => triggerAutoLogout()}
            variant="text"
          >
            {t('logout')}
          </Button>
        </>
      )}
    </Box>
  );
};

export default MetaNavigation;
